import { createSlice } from '@reduxjs/toolkit';

import { VerificationCodeStatus } from 'api/curo/VerificationProcessApi';
import { sendEmailVerificationCode, sendPhoneVerificationCode } from 'thunks';

import { resetCuroStore } from './actions';

export interface IVerificationProcessState {
  emailVerificationData: {
    sendingAttemptsLeft: number;
    status: VerificationCodeStatus;
  } | null;
  phoneVerificationData: {
    sendingAttemptsLeft: number;
    status: VerificationCodeStatus;
  } | null;
}

const initialState: IVerificationProcessState = {
  emailVerificationData: null,
  phoneVerificationData: null,
};

const verificationProcessSlice = createSlice({
  name: 'verificationProcess',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendEmailVerificationCode.fulfilled, (state, { payload }) => {
        state.emailVerificationData = payload;
      })
      .addCase(sendPhoneVerificationCode.fulfilled, (state, { payload }) => {
        state.phoneVerificationData = payload;
      })
      .addCase(resetCuroStore, () => initialState);
  },
});

export default verificationProcessSlice.reducer;
